/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Report } from '../../models/report';

export interface ReportsPut$Params {
  id: number;
      body: Report
}

export function reportsPut(http: HttpClient, rootUrl: string, params: ReportsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Report>> {
  const rb = new RequestBuilder(rootUrl, reportsPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Report>;
    })
  );
}

reportsPut.PATH = '/api/Reports/{id}';
